import Profile from "../assets/tabsimages/profile.png";
import CreateNFT from "../assets/tabsimages/createnft.png";
import MyNFT from "../assets/tabsimages/mynft.png";
import ValidatedUser from "../assets/tabsimages/validateduser.png";
import ValidateProfile from "../assets/tabsimages/validateprofile.png";

export const TABSARRAY = [{ url: "/myNFT", image: MyNFT },{ url: "/createNft", image: CreateNFT }, { url: "/Profile", image: Profile },  { url: "/Vscoredashboard", image: ValidatedUser }, { url: "/Xiodashboard", image: ValidateProfile }]